import React, {useCallback} from 'react';
import {ErrorData, Player} from 'app/components/team/playerstats/types';
import {windowIsDefined} from 'app/helpers/windowIsDefined';
import {desktopContentWidth} from 'app/styles/media';
import PlayerStatsGrid from 'app/components/team/playerstats/PlayerStatsGrid';

interface PlayerStatsSeasonGridProps {
  players: Player[];
  isLoading: boolean;
  error: ErrorData;
}

const MOBILE_OFFSET = 254;
export default function PlayerStatsSeasonGrid({players, isLoading, error}: PlayerStatsSeasonGridProps) {
  const calcMaxHeight = useCallback(() => {
    if (windowIsDefined && window.innerWidth < desktopContentWidth) {
      return window.innerHeight - MOBILE_OFFSET;
    }
    if (isLoading || !players.length || error) {
      return 350;
    }
    return '100%';
  }, [isLoading, players, error]);

  return (
    <PlayerStatsGrid
      type='season'
      players={players}
      isLoading={isLoading}
      error={error}
      calcMaxHeight={calcMaxHeight}
      withTopEleven={true}
      hideFooter={true}
      getRowHeight={() => 'auto'}
    />
  );
}
